import React from 'react';
import { AnimatedSection } from './AnimatedSection';
export function SoutheastAsiaMap() {
  return <AnimatedSection data-id="element-124">
      <div className="flex flex-col items-center" data-id="element-125">
        <svg viewBox="0 0 800 600" className="w-full max-w-4xl h-auto" xmlns="http://www.w3.org/2000/svg" data-id="element-126">
          {/* Myanmar */}
          <path d="M 180 120 L 200 100 L 220 110 L 230 140 L 240 180 L 235 220 L 225 250 L 215 270 L 200 280 L 185 275 L 175 260 L 170 240 L 165 210 L 170 180 L 175 150 Z" fill="#DDD3C5" fillOpacity="0.6" stroke="#A69070" strokeWidth="0.5" strokeOpacity="0.4" data-id="element-127" />

          {/* Thailand */}
          <path d="M 240 180 L 255 170 L 270 180 L 280 200 L 285 230 L 280 260 L 270 290 L 265 320 L 260 350 L 255 380 L 245 400 L 235 390 L 230 370 L 235 340 L 240 310 L 235 280 L 225 250 L 235 220 Z" fill="#E8DFD4" stroke="#A69070" strokeWidth="0.5" strokeOpacity="0.5" data-id="element-128" />

          {/* Laos */}
          <path d="M 285 230 L 300 220 L 315 230 L 325 250 L 330 270 L 325 290 L 315 305 L 305 310 L 295 305 L 285 290 L 280 270 L 280 250 Z" fill="#DDD3C5" fillOpacity="0.6" stroke="#A69070" strokeWidth="0.5" strokeOpacity="0.4" data-id="element-129" />

          {/* Vietnam */}
          <path d="M 330 270 L 345 260 L 360 265 L 370 280 L 375 300 L 380 330 L 385 360 L 380 390 L 370 410 L 360 420 L 350 415 L 345 400 L 340 380 L 335 360 L 330 340 L 325 320 L 320 300 L 325 280 Z" fill="#DDD3C5" fillOpacity="0.6" stroke="#A69070" strokeWidth="0.5" strokeOpacity="0.4" data-id="element-130" />

          {/* Cambodia */}
          <path d="M 305 310 L 320 305 L 335 315 L 345 330 L 350 345 L 345 360 L 335 370 L 320 375 L 305 370 L 295 360 L 290 345 L 290 330 L 295 320 Z" fill="#E8DFD4" stroke="#A69070" strokeWidth="0.5" strokeOpacity="0.5" data-id="element-131" />

          {/* Malaysia (Peninsula) */}
          <path d="M 260 380 L 270 370 L 280 375 L 285 390 L 290 410 L 285 430 L 280 450 L 270 465 L 260 470 L 250 465 L 245 450 L 245 430 L 250 410 L 255 395 Z" fill="#E8DFD4" stroke="#A69070" strokeWidth="0.5" strokeOpacity="0.5" data-id="element-132" />

          {/* Malaysia (Borneo - simplified) */}
          <path d="M 380 430 L 400 425 L 420 430 L 440 440 L 450 455 L 445 470 L 430 480 L 410 485 L 390 480 L 375 470 L 370 455 L 375 440 Z" fill="#E8DFD4" stroke="#A69070" strokeWidth="0.5" strokeOpacity="0.5" data-id="element-133" />

          {/* Indonesia (Sumatra - simplified) */}
          <path d="M 220 480 L 240 475 L 260 485 L 270 500 L 265 515 L 250 525 L 230 530 L 210 525 L 200 510 L 205 495 Z" fill="#DDD3C5" fillOpacity="0.6" stroke="#A69070" strokeWidth="0.5" strokeOpacity="0.4" data-id="element-134" />

          {/* Indonesia (Java - simplified) */}
          <path d="M 280 520 L 310 515 L 340 520 L 360 525 L 370 535 L 360 545 L 340 550 L 310 548 L 285 540 L 275 530 Z" fill="#DDD3C5" fillOpacity="0.6" stroke="#A69070" strokeWidth="0.5" strokeOpacity="0.4" data-id="element-135" />

          {/* Philippines (Luzon) */}
          <path d="M 520 200 L 540 195 L 555 205 L 565 220 L 570 240 L 565 260 L 555 275 L 540 280 L 525 275 L 515 260 L 510 240 L 515 220 Z" fill="#E8DFD4" stroke="#A69070" strokeWidth="0.5" strokeOpacity="0.5" data-id="element-136" />

          {/* Philippines (Visayas - simplified) */}
          <path d="M 530 290 L 545 288 L 555 295 L 560 305 L 555 315 L 545 320 L 530 318 L 520 310 L 520 300 Z" fill="#E8DFD4" stroke="#A69070" strokeWidth="0.5" strokeOpacity="0.5" data-id="element-137" />

          {/* Philippines (Mindanao) */}
          <path d="M 540 330 L 560 328 L 575 335 L 585 350 L 580 365 L 565 375 L 545 378 L 530 370 L 525 355 L 530 342 Z" fill="#E8DFD4" stroke="#A69070" strokeWidth="0.5" strokeOpacity="0.5" data-id="element-138" />

          {/* Blinking dots with labels */}

          {/* Thailand - Bangkok */}
          <g data-id="element-139">
            <circle cx="265" cy="320" r="5" fill="#C4342D" data-id="element-140" />
            <text x="280" y="325" fontSize="12" fill="#2D2A26" fontWeight="500" className="font-sans" data-id="element-141">
              Thailand
            </text>
          </g>

          {/* Cambodia - Phnom Penh */}
          <g data-id="element-142">
            <circle cx="320" cy="345" r="5" fill="#C4342D" data-id="element-143" />
            <text x="335" y="350" fontSize="12" fill="#2D2A26" fontWeight="500" className="font-sans" data-id="element-144">
              Cambodia
            </text>
          </g>

          {/* Malaysia - Kuala Lumpur */}
          <g data-id="element-145">
            <circle cx="270" cy="440" r="5" fill="#C4342D" data-id="element-146" />
            <text x="285" y="445" fontSize="12" fill="#2D2A26" fontWeight="500" className="font-sans" data-id="element-147">
              Malaysia
            </text>
          </g>

          {/* Philippines - Manila */}
          <g data-id="element-148">
            <circle cx="540" cy="240" r="5" fill="#C4342D" data-id="element-149" />
            <text x="555" y="245" fontSize="12" fill="#2D2A26" fontWeight="500" className="font-sans" data-id="element-150">
              Philippines
            </text>
          </g>
        </svg>
      </div>
    </AnimatedSection>;
}